<template>
    <div>
      <g-card :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
            <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
            />
  
          <div class="titulo-detalhes-cabecalho"> Observações do Pedido </div>
        </div>
  
        <div class="header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
            <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            @click="imprimir()"
            >
            </g-button>
        </div>
      </div>
  
      <div class="conteudo-card-parcelas-observacoes-andamento espacamento-detalhes">
        <div class="titulo-grupo-detalhes">Dados Gerais</div>
        <div class="grupo-dados-observacoes">
          <div class="pedido-parcela-grid">
            <div class="titulo-conteudo-detalhes">Pedido/Parcela</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.CodigoExternoPedido}} / {{observacoesPedidoAndamento.NumeroParcela}}</div>
          </div>
          <div class="orcamento-grid">
            <div class="titulo-conteudo-detalhes">Orçamento</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.CodigoExterno || 'Sem dados'}}</div>
          </div>
          <div class="tipo-grid">
            <div class="titulo-conteudo-detalhes">Tipo</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.TipoPedidoTexto || 'Sem dados'}}</div>
          </div>
          <div class="empresa-grid">
            <div class="titulo-conteudo-detalhes">Empresa</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.NomeEmpresa || 'Sem dados'}}</div>
          </div>
          <div class="representante-grid">
            <div class="titulo-conteudo-detalhes">Representante</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.NomeRepresentante || 'Sem dados'}}</div>
          </div>
          <div class="cliente-grid">
            <div class="titulo-conteudo-detalhes">Cliente/CNPJ</div>
            <div class="label-conteudo razaoSocialCnpj">{{observacoesPedidoAndamento.RazaoSocial}} / {{observacoesPedidoAndamento.CnpjFormatado}}</div>
          </div>
          <div class="ca-grid">
            <div class="titulo-conteudo-detalhes">CV</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.CurvaClienteTexto || 'Sem dados'}}</div>
          </div>
          <div class="produto-grid">
            <div class="titulo-conteudo-detalhes">Produto</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.NomeProduto || 'Sem dados'}}</div>
          </div>
          <div class="data-entrega-grid">
            <div class="titulo-conteudo-detalhes">Data Entrega</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.DataEntregaFormatada || 'Sem dados'}}</div>
          </div>
          <div class="data-carreg-grid">
            <div class="titulo-conteudo-detalhes">Data Carreg.</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.DataCarregamentoFormatada || 'Sem dados'}}</div>
          </div>
          <div class="data-base-grid">
            <div class="titulo-conteudo-detalhes">Data Base</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.DataBasePedidoParcelaFormatada || 'Sem dados'}}</div>
          </div>
          <div class="oc-grid">
            <div class="titulo-conteudo-detalhes">O.C.</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.NumeroOrdemDeCompra || 'Sem dados'}}</div>
          </div>
          <div class="liberado-grid">
            <div class="titulo-conteudo-detalhes">Liberado para produzir</div>
            <div class="label-conteudo">{{observacoesPedidoAndamento.LiberadoParaProduzir === true ? 'Sim' : 'Não' || 'Sem dados'}}</div>
          </div>
          <div class="qtde-grid">
            <div class="titulo-conteudo-detalhes">Qtde</div>
            <div class="label-conteudo">{{formataDecimal(observacoesPedidoAndamento.NumeroQuantidadeTotal) || 'Sem dados'}}</div>
          </div>
          <div class="qtde-produzida-grid">
            <div class="titulo-conteudo-detalhes">Qtde Produzida</div>
            <div class="label-conteudo">{{formataDecimal(observacoesPedidoAndamento.QuantidadeProduzida) || 'Sem dados'}}</div>
          </div>
          <div class="qtde-expedida-grid">
            <div class="titulo-conteudo-detalhes">Qtde Expedida</div>
            <div class="label-conteudo">{{formataDecimal(observacoesPedidoAndamento.QuantidadeExpedida) || 'Sem dados'}}</div>
          </div>
          <div class="componente-grid">
            <div class="titulo-conteudo-detalhes">Componente</div>
            <div class="label-conteudo">{{ observacoesPedidoAndamento.ComponenteTipoEnumTexto || 'Sem dados'}}</div>
          </div>
          <div class="fase-producao-grid">
            <div class="titulo-conteudo-detalhes">Fase de produção</div>
            <div class="label-conteudo">{{ observacoesPedidoAndamento.DescricaoFaseProduto || 'Sem dados'}}</div>
          </div>
        </div>
        <div class="titulo-grupo-detalhes">Observações</div>
        <div v-if="this.observacoesInfoArray == 0" class="flex-container">
          <div class="titulo-conteudo-detalhes"> Essa Parcela não possui Observações </div>
        </div>
    
        <div class="grupo-obs" v-for="data in observacoesInfoArray" :key="data.pedidoParcelaId">
          <div class="label-conteudo-infos">
            <div class="label-conteudo-obs">
              <div class="fase-producao-grid">
                <div class="titulo-conteudo-detalhes">Observação {{ data.observacaoSequencia }}</div>
                <div class="conteudo-observacao">{{data.descricaoObservacao || 'Sem dados'}}</div>
              </div>
              <div class="fase-producao-grid">
                <div class="titulo-conteudo-detalhes">Origem</div>
                <div class="label-conteudo">{{data.descricaoOrigem || 'Sem dados'}}</div>
              </div>
              <div class="fase-producao-grid">
                <div class="titulo-conteudo-detalhes ">Destino</div>
                <div class="label-conteudo destino">{{data.descricaoDestino || 'Sem dados'}}</div>
              </div>
              <div class="fase-producao-grid">
                <div class="titulo-conteudo-detalhes">Tipo</div>
                <div class="label-conteudo">{{data.tipoPedidoTexto || 'Sem dados'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      </g-card>
    </div>
  </template>
  
  <script>
  import ObservacoesPedidosExpedidoFaturado from './ObservacoesPedidosExpedidoFaturado.js'
  export default ObservacoesPedidosExpedidoFaturado
  </script>
  
  <style scoped>
  .destino{
    line-break: anywhere;
    /* word-spacing: 10px; */
  }
    .header-titulo-voltar {
      width: 100%;
      display: flex;
      align-items: flex-end;
    }
  
    .titulo {
      color: #3e3e3e;
      text-align: left;
      font-family: "MontSerrat";
      font-weight: 500;
      margin-top: 15px;
    }
  
    .conteudo-observacao{
      font-family: monospace;
      max-width: 50ch;
      white-space: break-spaces;
    }
  
    .conteudo {
      color: #8a8a8a;
      text-align: left;
      font-family: "MontSerrat";
      margin-bottom: 10px;
    }
  
    .card-titulo-observacoes {
      color: #4f2c19;
      font-weight: bold;
      font-size: 1.1rem;
    }
  
    .grupo {
      color: #4f2c19;
      text-align: left;
      font-family: "MontSerrat";
      font-weight: bold;
      margin-top: 30px;
      display: flex;
    }
  
    .card-margin{
      margin-top: 3rem;
    }
  
  
    @media (min-width:310px) {
      .grupo-dados-observacoes{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(6, auto);
        column-gap: 3%;
    }
      .header-observacoes-pedido-andamento {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
      }
    }
  
  
    @media (min-width:368px) {
      .header-observacoes-pedido-andamento {
          grid-template-columns: 25% repeat(2, auto);
      }
    }
  
  
    @media (min-width:600px) {
      .grupo-dados-observacoes{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(3, auto);
        column-gap: 3%;
    }
      .header-observacoes-pedido-andamento {
          padding: 20px 0 10px;
      }
    }
  
  
    @media (min-width:801px) {
      .conteudo-card-parcelas-observacoes-andamento {
        padding: 0 30px;
      }
    }
  
  
    @media (min-width:1025px) {
      .grupo-dados-observacoes{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
      .grupo {
        font-size: 19px;
      }
  
      .observacoes-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: repeat(3, 1fr);
        row-gap: 2rem;
      }
  
    .conteudo-card-parcelas-observacoes-andamento {
        padding: 0 50px;
      }
  
      .razaoSocialCnpj{
        width: 250px;
      }
      
    }
  
  
    @media (min-width:1281px) {
      .razaoSocialCnpj{
        width: auto;
        max-width: 350px;
      }
      .grupo-dados-observacoes{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }

    .label-conteudo-obs{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
    }
  
  
  </style>
  